import Raven from "raven-js";
import ReactDefaultBatchingStrategy from "react-dom/lib/ReactDefaultBatchingStrategy";

import { RAVEN_DSN, IS_PROD } from "config/constants";

export const logBatchingStrategy = {
  get isBatchingUpdates () {
    return ReactDefaultBatchingStrategy.isBatchingUpdates;
  },
  batchedUpdates (...args) {
    try {
      ReactDefaultBatchingStrategy.batchedUpdates(...args);
    } catch (e) {
      if (IS_PROD) {
        if (!Raven.isSetup()) {
          Raven.config(RAVEN_DSN, {
            environment: process.env.ENV,
            release: process.env.RELEASE,
          }).install();
        }
        Raven.captureException(e);
      }
      throw e;
    }
  },
};



// WEBPACK FOOTER //
// ./src/utils/logBatchingStrategy.js